/**
 * Blog AJAX filtering — single delegated controller.
 *
 * - Tag checkboxes + pagination swap #BlogContent in place (no reload).
 * - Search routes to Shopify's native article search (blogs have no native text filter).
 * - All listeners are delegated from document, so they survive content swaps with no
 *   re-binding — this is what prevents the duplicate-request build-up of the old version.
 */
(function () {
  function blogContent() {
    return document.getElementById('BlogContent');
  }

  function baseUrl() {
    var bc = blogContent();
    var url = (bc && bc.dataset.url) || window.location.pathname.split('?')[0].split('#')[0];
    return url.replace(/\/$/, '');
  }

  function tagUrl() {
    var tags = [];
    document.querySelectorAll('.blog-filter-checkbox:checked').forEach(function (b) {
      tags.push(b.value);
    });
    var url = baseUrl();
    if (tags.length) url += '/tagged/' + tags.join('+');
    return url;
  }

  // Featured post only renders on page 1, so crossing that boundary needs a full load.
  function isFirstPage(href) {
    return href.indexOf('page=') === -1 || href.indexOf('page=1') !== -1;
  }

  var controller = null;

  function fetchContent(url, updateHistory) {
    var bc = blogContent();
    if (!bc) return;

    if (isFirstPage(url) !== isFirstPage(window.location.href)) {
      window.location.href = url;
      return;
    }

    if (controller) controller.abort(); // ponytail: last request wins; drop stale in-flight one
    controller = new AbortController();
    var signal = controller.signal;

    bc.classList.add('loading');

    fetch(url, {
      headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' },
      signal: signal
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var next = new DOMParser().parseFromString(html, 'text/html').getElementById('BlogContent');
        if (!next) throw new Error('No #BlogContent in response');
        bc.innerHTML = next.innerHTML;
        if (updateHistory) history.pushState({ url: url }, '', url);
        // Let Empire's rimg lib (re)scan the injected subtree so lazy images load.
        bc.dispatchEvent(new CustomEvent('theme:rimg:watch', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('blog:filtered', { detail: { url: url } }));
      })
      .catch(function (err) {
        if (err.name === 'AbortError') return; // superseded by a newer request
        window.location.href = url; // graceful fallback to a real navigation
      })
      .finally(function () {
        bc.classList.remove('loading');
      });
  }

  function runSearch() {
    var input = document.querySelector('.blog-filters__search-input');
    var term = input ? input.value.trim() : '';
    if (!term) {
      fetchContent(tagUrl(), true); // empty search = just apply current tags
      return;
    }
    window.location.href = '/search?type=article&q=' + encodeURIComponent(term);
  }

  // Tag checkbox toggled
  document.addEventListener('change', function (e) {
    if (e.target.classList && e.target.classList.contains('blog-filter-checkbox')) {
      fetchContent(tagUrl(), true);
    }
  });

  // Search submit (covers the submit button and Enter in the input)
  document.addEventListener('submit', function (e) {
    if (e.target.classList && e.target.classList.contains('blog-filters__form')) {
      e.preventDefault();
      runSearch();
    }
  });

  // Pagination -> AJAX
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.blog-pagination-container a');
    if (!link) return;
    e.preventDefault();
    var url = link.getAttribute('href');
    if (isFirstPage(url) !== isFirstPage(window.location.href)) {
      window.location.href = url;
    } else {
      fetchContent(url, true);
      var bc = blogContent();
      if (bc) bc.scrollIntoView({ behavior: 'smooth' });
    }
  });

  window.addEventListener('popstate', function (e) {
    if (e.state && e.state.url) fetchContent(e.state.url, false);
  });
})();
